import * as YAML from 'yaml';

export const yamlToJson = YAML.parse;
